
export class ZoneCapacity {
    public zoneId: number;
    public remainingRegistrationCapacity: number;
}
